import idb from "idb";

const dbPromise = idb.open("beautifulai", 1, upgradeDb => {
    upgradeDb.createObjectStore("assets");
    upgradeDb.createObjectStore("libraryItems");
    upgradeDb.createObjectStore("permissions");
    upgradeDb.createObjectStore("plans");
    upgradeDb.createObjectStore("presentations");
    upgradeDb.createObjectStore("sharedThemes");
    upgradeDb.createObjectStore("slides");
    upgradeDb.createObjectStore("sync");
    upgradeDb.createObjectStore("teams");
    upgradeDb.createObjectStore("userAssets");
    upgradeDb.createObjectStore("userFolders");
    upgradeDb.createObjectStore("userPlans");
    upgradeDb.createObjectStore("users");
});

class Storage {
    constructor(storeName) {
        this._storeName = storeName;
    }

    set(key, value) {
        return dbPromise.then(db => {
            const tx = db.transaction(this._storeName, "readwrite");
            tx.objectStore(this._storeName).put(value, key);
            return tx.complete;
        });
    }

    /**
     * Convenient method for storing a lot of keys.
     * @param keyValueMap
     * @returns {Promise.<*>}
     */
    setBulk(keyValueMap) {
        return dbPromise.then(db => {
            const tx = db.transaction(this._storeName, "readwrite");
            Object.keys(keyValueMap).map(key => {
                tx.objectStore(this._storeName).put(keyValueMap[key], key);
            });
            return tx.complete;
        });
    }

    get(key) {
        return dbPromise.then(db => {
            return db.transaction(this._storeName)
                .objectStore(this._storeName).get(key);
        });
    }

    del(key) {
        return dbPromise.then(db => {
            return db.transaction(this._storeName)
                .objectStore(this._storeName).delete(key);
        });
    }

    all() {
        const obj = {};
        return dbPromise.then(db => {
            const tx = db.transaction(this._storeName);
            const keys = [];
            const store = tx.objectStore(this._storeName);

            // This would be store.getAllKeys(), but it isn't supported by Edge or Safari.
            // openKeyCursor isn't supported by Safari, so we fall back
            (store.iterateKeyCursor || store.iterateCursor).call(store, cursor => {
                if (!cursor) return;
                obj[cursor.key] = cursor.value;
                cursor.continue();
            });

            return tx.complete.then(() => obj);
        });
    }
}

const storages = {};

export default {
    use(storeName) {
        let storage = storages[storeName];
        if (!storage) {
            storage = new Storage(storeName);
            storages[storeName] = storage;
        }
        return storage;
    }
};
